import { render, staticRenderFns } from "./Ztbxx.vue?vue&type=template&id=3d905960&scoped=true"
import script from "./Ztbxx.vue?vue&type=script&lang=js"
export * from "./Ztbxx.vue?vue&type=script&lang=js"
import style0 from "./Ztbxx.vue?vue&type=style&index=0&id=3d905960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d905960",
  null
  
)

export default component.exports